import React from 'react'
import Helmet from 'react-helmet'

import '../assets/scss/main.scss'

import Header from './Header'
import Menu from './Menu'
import Footer from './Footer'

class Layout extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isMenuVisible: false,
            loading: 'is-loading'
        }
        this.handleToggleMenu = this.handleToggleMenu.bind(this)
    }

    componentDidMount() {
        this.timeoutId = setTimeout(() => {
            this.setState({ loading: '' });
        }, 100);
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    handleToggleMenu(e) {
        this.setState({
            isMenuVisible: !this.state.isMenuVisible
        })
    }

    render() {
        const { children, goBackBtn, tale, health } = this.props

        return (
            <>
                <Helmet>
                    <link rel="icon" type="image/x-icon" href="/favicon.ico" />
                    <link rel="icon" type="image/png" href="/favicon.png" />
                </Helmet>
                <div className="mb-3">
                    <Header goBackBtn={goBackBtn} onToggleMenu={this.handleToggleMenu} />
                </div>
                <div className={`body ${this.state.loading} ${this.state.isMenuVisible ? 'is-menu-visible' : ''}`}>
                    <div id="wrapper">
                        {children}
                        {/* <Contact /> */}
                        <Footer tale={tale} health={health} />
                    </div>
                    <Menu onToggleMenu={this.handleToggleMenu} />
                </div>
            </>
        )
    }
}

export default Layout
